import type { Client } from '@studio/types';

const filterApiClientsByName = (apiAccess: Readonly<Client.Derived.Client[]>, filter: string) => {
  return apiAccess.filter((client) => client.name.toLowerCase().includes(filter.toLowerCase()));
};

export default filterApiClientsByName;
